import {
  ColumnLayout,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import PLCButton from 'features/plc/components/PLCButton';
import PLCToggleButton from 'features/plc/components/PLCToggleButton';
import {
  PLC_PATHS,
  VACUUM_ZONE,
} from 'features/plc/contracts/pressHMI.schema';
import { usePLCValue } from 'features/plc/providers/PLCProvider';
import React from 'react';

const VACUUM_MANUAL_ZONE_OPTIONS = [
  { label: 'Manual Vacuum Valve Off', value: VACUUM_ZONE.OFF },
  { label: 'Manual Vacuum Valve Upper', value: VACUUM_ZONE.UPPER },
  { label: 'Manual Vacuum Valve Lower', value: VACUUM_ZONE.LOWER },
];

export default function OverrideControls() {
  const airChillerOn = usePLCValue(PLC_PATHS.status.airChillerOn);
  const vacuumZoneValue = usePLCValue(PLC_PATHS.cmd.vacuumManualZone);
  const vacuumPowerOn = usePLCValue(PLC_PATHS.status.vacuumPowerOn);

  return (
    <SpaceBetween size="m">
      <Header>Overrides</Header>
      <ColumnLayout columns={3}>
        <SpaceBetween size="m">
          <PLCToggleButton
            path={PLC_PATHS.cmd.upperCylinderManualEnable}
            trueLabel="Disable upper cooler"
            falseLabel="Enable upper cooler"
            disabled={!airChillerOn}
            fullWidth
          />
          <PLCToggleButton
            path={PLC_PATHS.cmd.lowerCylinderManualEnable}
            trueLabel="Disable lower cooler"
            falseLabel="Enable lower cooler"
            disabled={!airChillerOn}
            fullWidth
          />
        </SpaceBetween>
        <SpaceBetween size="m">
          <PLCToggleButton
            path={PLC_PATHS.cmd.ionizerManualEnable}
            trueLabel="Manual turn ionizer off"
            falseLabel="Manual turn ionizer on"
            fullWidth
          />
          <PLCToggleButton
            path={PLC_PATHS.cmd.vacuumManualEnable}
            trueLabel="Manual turn vacuum power off"
            falseLabel="Manual turn vacuum power on"
            disabled={!airChillerOn}
            fullWidth
          />
          {VACUUM_MANUAL_ZONE_OPTIONS.map((option) => (
            <PLCButton
              key={`vacuumZone-${option.value}`}
              path={PLC_PATHS.cmd.vacuumManualZone}
              value={option.value}
              variant={vacuumZoneValue === option.value ? 'primary' : 'normal'}
              disabled={!vacuumPowerOn}
              fullWidth
            >
              {option.label}
            </PLCButton>
          ))}
        </SpaceBetween>
      </ColumnLayout>
    </SpaceBetween>
  );
}
